/* eslint-disable react-hooks/rules-of-hooks */
import { useAuth } from "@/context/AuthContext";
import {
  Bell,
  FileClockIcon,
  HelpCircle,
  LogOutIcon,
  ReceiptText,
  User2Icon,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { API_CONFIG } from "@/config/apiConfig";
import barsIcon from "/img/svg/bars.svg";
import { useEffect, useMemo, useState } from "react"; 
import { getNotificationIcon } from "@/utils/notifications/notificationIcon";
import { markNotificationAsRead } from "@/utils/notifications/notificationActions";
import { useNotifications } from "@/hooks/use-notifications";

export const DashboardHeader = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const { user } = useAuth();
  const userId = user?.id;

  const { notifications } = useNotifications(userId);
  const [showDropdown, setShowDropdown] = useState(false);

  const unreadCount = notifications.filter((n) => !n.is_read).length;

  useEffect(() => {
    const sidebarToggle = document.querySelector(".sidebar-toggle");

    const sidebarCollapse = () => {
      document.querySelector(".overlay-dark-sidebar")?.classList.toggle("show");
      document.querySelector(".sidebar")?.classList.toggle("sidebar-collapse");
      document.querySelector(".sidebar")?.classList.toggle("collapsed");
      document.querySelector(".contents")?.classList.toggle("expanded");
    };

    if (sidebarToggle) {
      sidebarToggle.addEventListener("click", sidebarCollapse);
    }

    return () => {
      if (sidebarToggle) {
        sidebarToggle.removeEventListener("click", sidebarCollapse);
      }
    };
  }, []);

  return (
    <header className="header-top">
      <nav className="navbar navbar-light">
        <div className="navbar-left">
          <a className="sidebar-toggle" style={{ cursor: "pointer" }}>
            <img className="svg" src={barsIcon} alt="img" />
          </a>
          <a className="navbar-brand" href="#">
            <img className="dark" src="/images/logo.png" alt="svg" />
          </a>
          {/* <form action="/" className="search-form">
            <SearchIcon></SearchIcon>
          </form> */}
        </div>
        <div className="navbar-right">
          <ul className="navbar-right__menu">
            <li className="nav-notification">
              <div className="dropdown-custom">
                <a
                  href="#"
                  className="nav-item-toggle"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowDropdown(!showDropdown);
                  }}
                >
                  <Bell size={16} />

                  {/* {unreadCount > 0 && (
                    <span className="badge-circle badge-warning ml-1">
                      {unreadCount}
                    </span>
                  )} */}
                </a>

                {showDropdown && (
                  <div className="dropdown-wrapper">
                    <h2 className="dropdown-wrapper__title">
                      Notifications
                      <span className="badge-circle badge-warning ml-1">
                        {unreadCount}
                      </span>
                    </h2>

                    <ul style={{ maxHeight: "300px", overflowY: "auto" }}>
                      {notifications.length === 0 && (
                        <li style={{ padding: "10px" }}>No notifications</li>
                      )}

                      {notifications.slice(0, 5).map((n) => {
                        const { icon, className } = getNotificationIcon(n.type);

                        return (
                          <li
                            key={n.id}
                            onClick={() => markNotificationAsRead(n.id)}
                            className={`nav-notification__single d-flex flex-wrap ${
                              !n.is_read
                                ? "nav-notification__single--unread"
                                : ""
                            }`}
                            style={{
                              background: !n.is_read ? "#f5f8ff" : "#fff",
                            }}
                          >
                            <div
                              className={`nav-notification__type ${className}`}
                            >
                              {icon}
                            </div>

                            <div className="nav-notification__details">
                              <p>
                                <span
                                  className="subject text-truncate"
                                  style={{ maxWidth: "180px" }}
                                >
                                  {n.title}
                                </span>
                                <span> {n.message}</span>
                              </p>

                              <p>
                                <span className="time-posted">
                                  {n.created_at
                                    ?.toDate?.()
                                    ?.toLocaleString?.() || ""}
                                </span>
                              </p>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                    <a href="#" className="dropdown-wrapper__more">
                      See all incoming activity
                    </a>
                  </div>
                )}
              </div>
            </li>
            
            <li className="nav-author">
              <div className="dropdown-custom">
                <a className="nav-item-toggle">
                  <img
                    src={
                      user?.profile_image
                        ? API_CONFIG.domain + user.profile_image
                        : "/img/author-nav.jpg"
                    }
                    alt=""
                    className="rounded-circle"
                  />
                </a>
                <div className="dropdown-wrapper">
                  <div className="nav-author__info">
                    <div className="author-img">
                      <img
                        src={
                          user?.profile_image
                            ? API_CONFIG.domain + user.profile_image
                            : "img/author-nav.jpg"
                        }
                        alt=""
                        className="rounded-circle"
                      />
                    </div>
                    <div>
                      <h6>
                        {user.f_name.charAt(0).toUpperCase() +
                          user.f_name.slice(1) +
                          " " +
                          user.l_name}
                      </h6>
                    </div>
                  </div>
                  <div className="nav-author__options">
                    <ul>
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/my-profile");
                          }}
                        >
                          <User2Icon />
                          My Profile
                        </a>
                      </li>
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault(); // stop page reload
                            navigate("/billing"); // navigate to Billing page
                          }}
                        >
                          <ReceiptText /> Billing
                        </a>
                      </li>
                      {/* <li>
                        <a href="">
                          <FileClockIcon /> Activity
                        </a>
                      </li> */}
                    </ul>
                    <div className="text-center nav-author__signout cursor-pointer">
                      <a
                        onClick={logout}
                        className="d-flex gap-3 justify-content-center w-100"
                      >
                        <LogOutIcon />
                        <span>Sign Out</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};
